module.exports = __webpack_public_path__ + "img/task-light.e46604a4.svg";